import React, { Component } from 'react';
import "./CustomerServiceHelp.css";
import { Celebration, Close, CloseRounded, ContactSupport, LiveHelp, OpenInNew, PartyMode, PersonOutline, PhonePaused, Scoreboard as ScoreboardIcon, Search, Sell, Support, Tag, ThumbUp } from '@mui/icons-material';
import Api from '../../customlib/Api';
import Global from '../../customlib/Global';
import axios from 'axios';
import CsContactListItem from './CsContactListItem';
import { CircularProgress, TextField, Tooltip, Paper, Box, Chip, Typography, Divider, FormGroup, FormControlLabel, Switch, Tooltip as ToolTip, Badge, IconButton, Menu, MenuItem, LinearProgress, Dialog, DialogTitle, DialogContent, DialogActions, Link as MuiLink, Alert } from '@mui/material';
import { styled } from '@mui/styles';

const SEARCH_FIELDS = [
  { key: "fromName", label: "Nama", icon: <PersonOutline sx={{ fontSize: 15 }} /> },
  { key: "from", label: "Nomor", icon: <Tag sx={{ fontSize: 15 }} /> },
  { key: "label", label: "Label", icon: <Sell sx={{ fontSize: 15 }} /> },
];

class AntrianCustomerCs extends Component {
  state = {
    listMycustomer: [],
    page: 0,
    rowsPerPage: 30,
    keyword: "",
    useLimit: false,
    isLoading: true,
    searchMode: false,
    searchInAllContact: false,
    searchInField: "fromName",
    anchorElJustRead: null,
    openMenuJustRead: false,
    // CS Ticketing (PRD v1.3.0)
    tickets: [],          // keyed by customer_wa_number (from)
    queueUrl: "https://daftarantriancs.com",
    queueMode: "queue",   // 'queue' (CS idle) | 'active' (CS sedang handle 1 tiket)
  }

  constructor(){
    super();
    
    // Global.getSocket().on("helpRequestChanged", data => {
    //   console.log("helpRequestChanged : ", data);
    //   if(this.state.searchMode === false){
    //     this.updateCsHelpData(data);
    //     this.getCsHelpList();
    //     // this.props.onUpdateCsHelpState(data);
    //   }
    //   // this.props.onUpdateCsHelpState(data);
      
    // });

    Global.getSocket().on("helpRequestChanged", data => {
      console.log("helpRequestChanged : ", data);

      if(Global.get() === undefined || Global.get() === null){
        return;
      }

      if(this.state.searchMode === false){
        this.updateCsHelpData(data);
        this.getCsHelpList();
        // this.props.onUpdateCsHelpState(data);
      }
      
    });

    Global.getSocket().on("newMessageComing", data => {
      console.log("LOG__NEW_MESSAGE_COMING_LOCAL", data, );
      // console.log("NEW_MESSAGE_COMING_LOCAL",Global.getAppProfile().waNumber, data.to);
      // let isNewContact = data.isNewContact ?? false;

      if(Global.get() === undefined || Global.get() === null){
        return;
      }

      if(Global.getAppProfile().waNumber !== data.to){
        return;
      }

      if(data.contact.csHelpState !== "OPEN"){
        return;
      }

      console.log("LOG__CURRENT_CONV_CHECK", this.props.currentConversation);
      if(this.props.currentConversation !== undefined && data.from === this.props.currentConversation.fromNumber){
        this.getCsHelpList();
          // let lastMessage = "";
          // if(data.message.text !== undefined){
          //   lastMessage = data.message.text;
          // }else{
          //   if(data.message.caption !== undefined){
          //     lastMessage = data.message.caption;
          //   }else if(data.message.type === "STICKER"){
          //     lastMessage = "Stiker";
          //   }
          // }
          
          // this.setState({ mustSendGreeting: false }, () => this.scrollToMyRef());

          // this.props.onNewIncomingMessage(this.props.currentConversation, lastMessage);
          // this.props.onResetUnreadCounter(this.props.currentConversation.id, false);
      }else{
          // this.props.onUpdateReadCounter(data);
          this.getCsHelpList();
      }

      // var isMyContact = false;
      // try{
      //   isMyContact = this.props.conversationList.filter((contact) => contact.fromNumber===data.from);
      // }catch(err){

      // }

      // if(this.state.muteSound === true){
      //   return;
      // }

      // if(Global.get().admin === true){
      //   try{
      //     if(isNewContact){
      //       this.state.newContactAudio.play();
      //     }else{
      //       this.state.audio.play();
      //     }
          
      //   }catch(err){
      //     console.log("PLAYERROR", err);
      //   }
      // // }else if(data.assignToUserId === Global.get().user.id){
      // }else if(isMyContact.length > 0 || data.assignToUser === Global.get().user.id){
      //   try{
      //     if(isNewContact){
      //       this.state.newContactAudio.play();
      //     }else{
      //       this.state.audio.play();
      //     }
      //   }catch(err){
      //     console.log("PLAYERROR", err);
      //   }
      // }

    });

    
   
  }

  handleClosePopupMenuJustRead = () => {
    this.setState({openMenuJustRead: false, anchorElJustRead: null}, () => {
      // this.setState({anchorEl: null});
    });
  };

  handleJustReadMenuClicked = (event) => {
    this.setState({anchorElJustRead: event.currentTarget, openMenuJustRead: true}, () => {
      this.props.onUpdateJustRead();
    });
  };

  handleKeyword = (event) => {
    this.setState({ keyword: event.target.value });
  };

  onKeyDownHandler = e => {
    if (e.keyCode === 13) {
      this.getCsHelpList();
    }
  };

  updateCsHelpData = (data) => {
    const csHelpList = [...this.state.listMycustomer];
    let contact = csHelpList.filter((conv) => conv.contactId===data.contactId);

    if(contact.length > 0){
      contact[0].csHelpState = data.helpState;
      if(data.csNote !== undefined){
        contact[0].csNote = data.csNote;
      }

      if(data.label !== undefined){
        contact[0].contactLabel = data.label;
      }

      this.setState({listMycustomer: csHelpList});
    }else{
      this.getCsHelpList();
    }

  }

  getCsHelpList = () => {

    // if(this.state.keyword.length <= 0){
    //   this.setState({listMycustomer: []});
    //   return;
    // }

    this.setState({isLoading: true}, () => {
      var userData = Global.get();
      const params = {
          userId: userData.user.id,
          // appProfileId: Global.getAppProfile()._id
          appProfileId: Global.getSwitchAppProfileId()
      }

      if(this.state.searchMode === true){
        params.query = this.state.keyword;
        params.searchInAllContact = this.state.searchInAllContact;
        params.searchInField = this.state.searchInField
      }

      console.log("PARAMS", params);

      axios
      .post(Api.csInQueueCustomers(), params, Api.getRequestHeader())
      .then((response) => {
          console.log("MyCustomerToday : ", response.data.data);
          var customers = response.data.data;
          var contacts = [];
          customers.forEach(customer => {
              let newData =  {
                photo: "https://picsum.photos/seed/picsum/200",
                fromName: `${customer.fromName}`,
                text: customer.lastMessage,
                fromNumber: customer.from,
                contactId: customer.id,
                toNumber: customer.to,
                toName: customer.toName,
                selected: false,
                unreadCounter: customer.unreadCounter,
                assignToUserName: customer.assignToUserName,
                csHelpState: customer.csHelpState,
                showButton: true,
                csNote: customer.csNote,
                lastWaCsLog: customer.lastWaCsLog,
                contactLabel: customer.label,
                firstContactAssignedToName: customer.firstContactAssignedToName,
                lastMessageTime: customer.lastMessageTime,
                csCreatedAt: customer.csCreatedAt,
                csId: customer.csId,
                csName: customer.csName
                };
              contacts.push(newData);
          });

          this.setState({listMycustomer: contacts, isLoading: false});
      })
      .catch((error) => {
        this.setState({isLoading: false});
        console.error("There was an error!", userData.user.id, error);
      });
    });

    // Refresh ticket queue in parallel — pakai endpoint baru supaya dapat queue_label + ticket_number
    this.loadTicketQueue();

  };

  getFieldClassName = (fieldName) => {
    let className = "badge";
    if(this.state.searchInField === fieldName){
      className += " badge-primary";
    }else{
      className += " badge-secondary";
    }

    return className;
  }

  handleFieldSelectionChanged = (fieldName) => {
      this.setState({searchInField: fieldName}, () => {
        this.getCsHelpList();
      });
  }

  getUsersBySlugRole = () => {

    // if(this.state.keyword.length <= 0){
    //   this.setState({listMycustomer: []});
    //   return;
    // }

    this.setState({isLoading: true}, () => {
      var userData = Global.get();
      const params = {
          slugRole: "nightshift"
      }
      console.log("PARAMS", params);

      axios
      .post(Api.usersBySlugRole(), params, Api.getRequestHeaderJsonNew())
      .then((response) => {
          console.log("Users By Slug Role : ", response.data);
          // var customers = response.data.data;
          // var contacts = [];
          // customers.forEach(customer => {
          //     let newData =  {
          //       photo: "https://picsum.photos/seed/picsum/200",
          //       fromName: `${customer.fromName}`,
          //       text: customer.lastMessage,
          //       fromNumber: customer.from,
          //       contactId: customer.id,
          //       toNumber: customer.to,
          //       toName: customer.toName,
          //       selected: false,
          //       unreadCounter: customer.unreadCounter,
          //       assignToUserName: customer.assignToUserName,
          //       csHelpState: customer.csHelpState,
          //       showButton: true,
          //       csNote: customer.csNote,
          //       lastWaCsLog: customer.lastWaCsLog,
          //       contactLabel: customer.label,
          //       firstContactAssignedToName: customer.firstContactAssignedToName
          //       };
          //     contacts.push(newData);
          // });

          // this.setState({listMycustomer: contacts, isLoading: false});
      })
      .catch((error) => {
        this.setState({isLoading: false});
        console.error("There was an error!", userData.user.id, error);
      });
    });

  };

  handleUpdateNote = (conversation, note) => {
    const conversations = [...this.state.listMycustomer];
    let contact = conversations.filter((conv) => conv.contactId===conversation.contactId);

    if(contact.length > 0){
      console.log("CONTACTFOND : ", contact);
      contact[0].csNote = note;

      this.setState({isSavingNote: false, listMycustomer: conversations, isEditingNote: false});
    }
  }

  handleSwitchLeads = () => {
    let mode = false;
    if(this.state.searchMode === true){
      mode = false;
    }else{
      mode = true;
    }

    this.setState({searchMode: mode, keyword: ""}, () => {
      this.getCsHelpList();
    });

  }

  handleSwitchSearchContext = () => {
    let mode = false;
    if(this.state.searchInAllContact === true){
      mode = false;
    }else{
      mode = true;
    }

    this.setState({searchInAllContact: mode, keyword: this.state.keyword}, () => {
      this.getCsHelpList();
    });

  }

  componentDidMount() {
    this.getCsHelpList();
    this.getUsersBySlugRole();
    this.loadTicketQueue();

    // Fallback polling 10s — handle cases saat socket event miss (mis. socket
    // disconnect sebentar, atau browser tab inactive). Socket event tetap
    // primary channel; polling sebagai safety net.
    this.pollTimer = setInterval(() => {
      this.loadTicketQueue();
      if (!this.state.searchMode) {
        this.getCsHelpList();
      }
    }, 30000);

    // setTimeout(() => {
    //   this.props.onUpdateJustRead()
    // }, 3000)
  }

  componentWillUnmount() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  }

  /**
   * Fetch antrian tiket dari CsTicketController::queueForAgent().
   * Smart: kalau CS sedang handle 1 tiket, return itu saja (1-ticket mode).
   * Hasilnya di-index by customer wa number lalu di-merge ke listMycustomer
   * pada saat render, sehingga tiap card bisa tampilkan queue label + ticket number.
   */
  loadTicketQueue = () => {
    axios
      .get(Api.csTicketQueueForAgent(), Api.getRequestHeader())
      .then((response) => {
        if (!response.data || !response.data.success) {
          return;
        }
        const d = response.data.data;
        const byWa = {};
        (d.tickets || []).forEach((item) => {
          const t = item.ticket;
          if (t && t.customer_wa_number) {
            byWa[t.customer_wa_number] = t;
          }
        });
        this.setState({
          tickets:   byWa,
          queueUrl:  d.queue_url  || this.state.queueUrl,
          queueMode: d.mode       || "queue",
        });
      })
      .catch((error) => {
        // Modal harus tetap jalan kalau endpoint baru belum tersedia
        console.warn("loadTicketQueue failed:", error?.message);
      });
  };

  handleOpenChat = (conversation) => {
    if (typeof this.props.onSelect === 'function') {
      this.props.onSelect(conversation);
    }

    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  render() {
    const { tickets, queueUrl, queueMode, listMycustomer } = this.state;

    // Merge ticket info ke tiap contact. Kalau queueMode = 'active' (CS sedang
    // handle 1 tiket), kita filter list jadi hanya customer yang match tiket
    // itu supaya sesuai POV "list antrian hanya tampilkan 1 ticket saja".
    const enrichedList = listMycustomer.map((conv) => {
      const t = tickets && tickets[conv.fromNumber];
      if (!t) return conv;
      return {
        ...conv,
        queueLabel:    t.queue_label,
        ticketNumber:  t.ticket_number,
        ticketStatus:  t.status,
        ticketCategory: t.category,
        ticketId:      t.id,
      };
    });

    let visibleList = enrichedList;
    if (queueMode === 'active') {
      // Ketika CS sedang handle, tampilkan hanya tiket yg lagi dihandle.
      const active = enrichedList.filter((c) => c.ticketStatus === 'sedang_ditangani');
      if (active.length > 0) {
        visibleList = active;
      } else if (tickets && Object.keys(tickets).length > 0) {
        // Fallback: contact tidak ada di listMycustomer (setelah START,
        // csHelpState berubah jadi SOLVING sehingga hilang dari csInQueueCustomers).
        // Construct virtual card dari ticket data agar CS tetap bisa lihat kontak
        // yang lagi dihandle + tombol OPEN CHAT.
        visibleList = Object.values(tickets).map((t) => ({
          contactId:        null,
          fromNumber:       t.customer_wa_number,
          fromName:         t.customer_name || t.customer_wa_number,
          text:             '', // unknown, would need a separate fetch
          unreadCounter:    0,
          assignToUserName: Global.get().user.name,
          csHelpState:      'SOLVING',
          showButton:       true,
          csNote:           null,
          contactLabel:     t.category === 'komplain' ? 'complaint' : 'konfirmasi',
          csName:           Global.get().user.name,
          csCreatedAt:      t.handled_at,
          queueLabel:       t.queue_label,
          ticketNumber:     t.ticket_number,
          ticketStatus:     t.status,
          ticketCategory:   t.category,
          ticketId:         t.id,
        }));
      }
    }

    return (
      <>
        <Paper variant="outlined" sx={{ mx: 0.5, mb: 1.5, p: 1.5, borderRadius: "10px" }}>
          {/* Link antrian customer untuk dibagikan ke customer */}
          {queueUrl && (
            <Alert severity="info" icon={false} sx={{ mb: 1, py: 0.5, borderRadius: "8px" }}>
              <div style={{fontSize: '11px'}}>
                <b>Link Antrian Customer:</b>&nbsp;
                <MuiLink href={queueUrl} target="_blank" rel="noopener noreferrer" underline="hover">
                  {queueUrl} <OpenInNew sx={{ fontSize: 12, verticalAlign: 'text-bottom' }} />
                </MuiLink>
              </div>
            </Alert>
          )}
          {queueMode === 'active' && (
            <Alert severity="warning" sx={{ mb: 1, py: 0.5, fontSize: '11px', borderRadius: "8px" }}>
              Mode: Tangani 1 Tiket. Selesaikan tiket ini dulu sebelum ambil tiket berikutnya.
            </Alert>
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: this.state.searchMode ? "#fff3e0" : "#e8f5e9",
              borderRadius: "8px",
              py: 0.5,
            }}
          >
            <FormControlLabel
              sx={{ m: 0 }}
              label={
                <Box component="span" sx={{ fontSize: "0.8rem", fontWeight: 600, color: this.state.searchMode ? "#ef6c00" : "#2e7d32" }}>
                  {this.state.searchMode === true ? "Search Mode (ON), Realtime Off" : "Search Mode (OFF), Realtime On"}
                </Box>
              }
              control={
                <Switch
                  checked={this.state.searchMode}
                  onChange={this.handleSwitchLeads}
                  name="switchLeads"
                  size='small'
                />
              }
            />
          </Box>

          {this.state.searchMode === true && (
            <Box sx={{ mt: 1.5 }}>
              <TextField
                onChange={this.handleKeyword}
                label="Cari nama / no wa / label"
                type="text"
                id="searchCustomer"
                variant="outlined"
                onKeyDown={this.onKeyDownHandler}
                fullWidth
                size='small'
                InputProps={{ startAdornment: <Search sx={{ fontSize: 18, color: "text.secondary", mr: 1 }} /> }}
              />

              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 1, flexWrap: "wrap" }}>
                <Typography variant="caption" color="text.secondary">Cari berdasarkan:</Typography>
                {SEARCH_FIELDS.map((field) => (
                  <Chip
                    key={field.key}
                    icon={field.icon}
                    label={field.label}
                    size="small"
                    clickable
                    onClick={() => this.handleFieldSelectionChanged(field.key)}
                    color={this.state.searchInField === field.key ? "primary" : "default"}
                    variant={this.state.searchInField === field.key ? "filled" : "outlined"}
                    sx={{ fontWeight: 600 }}
                  />
                ))}
              </Box>

              {Global.get().admin && !Global.isCustomerService() && (
                <Box sx={{ textAlign: "right", mt: 0.5 }}>
                  <FormControlLabel
                    label={<Typography variant="caption">Cari di semua kontak</Typography>}
                    control={
                      <Switch
                        checked={this.state.searchInAllContact}
                        onChange={this.handleSwitchSearchContext}
                        name="switchSearchContext"
                        color="primary"
                        size="small"
                      />
                    }
                  />
                </Box>
              )}
            </Box>
          )}

          {this.state.isLoading === true && <LinearProgress sx={{ mt: 1, borderRadius: "4px" }} />}
        </Paper>
        {/* <div style={{overflowY: 'scroll', marginBottom: 10, maxHeight: 500, position: "static"}}> */}
        <div style={{marginBottom: 10, position: "static"}}>
          {
            visibleList.map((conversation) => {
              
              return (
                <CsContactListItem
                  onSelect={conversation.csHelpState === "OPEN" ? () => {this.props.showSnackBar('Klik tombol "START" untuk memulai conversation dengan ' + conversation.fromName)} : this.props.onSelect}
                  key={conversation.fromNumber}
                  data={conversation}
                  onUpdateNote={this.handleUpdateNote}
                  reloadCsHelpList={this.getCsHelpList}
                  onCustomerStarted={this.props.onCustomerStarted}
                  onOpenChat={this.handleOpenChat}
                  showSnackBar={this.props.showSnackBar}
                />
              )
                    
              })
          }
        </div>
        {/* <Dialog 
          open={true}>
            <DialogTitle>
              <div className="row">
                <div className="col-10" style={{paddingTop: "5px"}}>
                  Antrian Customer CS
                </div>
                <div className="col-2 text-right">
                  <IconButton><Close /></IconButton>
                </div>
              </div>
            </DialogTitle>
          <DialogContent>
            <div style={{marginBottom: 10, position: "static"}}>
            {
              this.state.listMycustomer.map((conversation) => {
                
                return (
                  <CsContactListItem
                    onSelect={conversation.csHelpState === "OPEN" ? () => {this.props.showSnackBar('Klik tombol "START" untuk memulai conversation dengan ' + conversation.fromName)} : this.props.onSelect}
                    key={conversation.fromNumber}
                    data={conversation}
                    onUpdateNote={this.handleUpdateNote}
                    reloadCsHelpList={this.getCsHelpList}
                    // onBtnEditNoteClick={this.handleToggleShowNoteInput}
                    // onUpdateHelpState={this.handleSetHelpState}
                    // isSavingNote={this.state.isSavingNote}
                    // onSaveNote={this.handleSaveNote}
                    // isEditingNote={this.state.isEditingNote}
                    // savingNoteContactId={this.state.savingNoteContactId}
                  />
                )
                      
                })
            }
          </div>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog> */}
      </>
    );
  }
}
 
export default AntrianCustomerCs;

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}));
